import { BaseReportBloc } from './bloc.base';

export class BoxReportBloc extends BaseReportBloc {

}
